import styled from "styled-components";
import { Link } from "react-router-dom";
import { TypoTitle1, TypoFine2 } from "@/styles/Styled.Typography";
import { fluid } from "@/styles/utils/fluid";

export const ArticleLink = styled(Link)`
  display: flex;
  flex-direction: column;
  color: ${({ theme }) => theme.colors.onyx};
  h2 {
    transition: all 0.3s ease-in-out;
  }
  &:hover h2 {
    color: ${({ theme }) => theme.colors.imperialRed};
  }
  p {
    margin-bottom: 0;
    padding-bottom: ${({ theme }) => theme.spacing.element.xs}rem !important;
  }
  padding: ${({ theme }) =>
    fluid({
      minSize: theme.spacing.element.xs,
      maxSize: theme.spacing.element.xl,
      minVW: theme.breakpointValues.xs, // 900
      maxVW: theme.breakpointValues.xl, // 1200 or 1800?
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })};
`;

export const ArticleTitle = styled(TypoTitle1)`
  padding-bottom: ${({ theme }) => theme.spacing.element.xs}rem;
`;

export const ChipLabelWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing.element.xs}rem;
  white-space: nowrap;
  padding-top: calc(${({ theme }) => theme.fontScale.majorSecond.size} / 2) rem;
`;

export const ChipLabel = styled(TypoFine2)`
  background-color: ${({ theme }) => theme.colors.platinum};
  padding: 8px;
  border-radius: 8px;
  height: min-content;
  width: min-content;
  text-transform: capitalize;
  white-space: nowrap;
`;

export const OutlineWrapper = styled.div`
  width: 100%;
  border-top: 4px solid ${({ theme }) => theme.colors.onyx};
  border-bottom: 4px solid ${({ theme }) => theme.colors.onyx};
  article {
    border-bottom: 1px solid ${({ theme }) => theme.colors.onyx};
    &:last-child {
      border-bottom: none;
    }
    p {
      padding: 0;
    }
  }
`;

export const OutlineContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) =>
    fluid({
      minSize: theme.spacing.element.xs,
      maxSize: theme.spacing.element.xl,
      minVW: theme.breakpointValues.xs,
      maxVW: theme.breakpointValues.xl,
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })};
`;
